//#region src/hash-scroll.ts
/**
* @private
* Handles hash-based scrolling after navigation completes.
* To be used in framework-specific <Transitioner> components during the onResolved event.
*/
function handleHashScroll(router) {
	if (typeof document !== "undefined" && document.querySelector) {
		const location = router.stores.location.get();
		const hashScrollIntoViewOptions = location.state.__hashScrollIntoViewOptions ?? true;
		if (hashScrollIntoViewOptions && location.hash !== "") {
			const el = document.getElementById(location.hash);
			if (el) el.scrollIntoView(hashScrollIntoViewOptions);
		}
	}
}
//#endregion
export { handleHashScroll };

//# sourceMappingURL=hash-scroll.js.map